import React from "react";

const MyRecordsWeight = () => {
  return (
    <div className="patient-details_first-section">
      <h3>Weight (kg)</h3>
      <span className="weight_input"></span>
    </div>
  );
};

export default MyRecordsWeight;
